export const CREATE_WEDDING_APP_NAME = 'createwedding';
export const CREATE_WEDDING_KEY = '@@createwedding';
